import { Typography } from '@sravni/react-design-system';

import { Currency } from '@src/@types/currency';
import type { AffSub4 } from '@src/@types/microcredits';
import { AdvertisingButton } from '@src/components/AdvertisingButton';
import { Logo } from '@src/components/Logotype';
import type { IAnalyticsItem } from '@src/helpers/analyticsEvents';
import { getAmountString } from '@src/helpers/common';
import { getDaysPluralize } from '@src/helpers/strings';

import styles from './styles.module.scss';

type Props = {
  analytics: IAnalyticsItem;
  affSub4: AffSub4;
  amount: number;
  term: number;
  logo: string;
  advSub: string;
};

const { Heading, Text } = Typography;

export const StickyBlock = ({ analytics, affSub4, term, amount, logo, advSub }: Props) => {
  const amountText = getAmountString(amount, Currency.RUB);
  const pluralizeTerm = getDaysPluralize(term);
  const termText = `на ${term} ${pluralizeTerm}`;

  return (
    <div className={styles.stickyWrapper}>
      <div className={styles.content}>
        <Logo link={{ href: '', withAdvertising: false }} logo={logo} size={44} />
        <div>
          <Heading level={4}>{amountText}</Heading>
          <Text className="h-color-D40" size={12}>
            {termText}
          </Text>
        </div>
      </div>
      <AdvertisingButton
        className={styles.button}
        source="search"
        advSub={advSub}
        analytics={analytics}
        affSub4={affSub4}
        size={44}
      />
    </div>
  );
};
